import { useIntl, getIntl } from "@umijs/max";
function capitalizeWords(str) {
  return str.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}
const createT = (intl) => {
  const umiIntl = intl || getIntl();
  const t = (id, options) => {
    const { values } = options || {};
    const text = umiIntl.formatMessage({ id }, values);
    return capitalizeWords(text);
  };
  return t;
};
const useT = () => {
  const umiIntl = useIntl();
  return createT(umiIntl);
};
const getT = () => {
  return createT(void 0);
};
export {
  getT,
  useT
};
